import { createRequest, RequestConfig } from 'app/common/api';

import { TRouteConstraints } from '../core/route-constraints';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/get_routes',
};

export const getRoutesRequest = (constraints?: TRouteConstraints) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(constraints),
  });
